import { LeaderBoardTableFrame } from "../Components/Frame"
import { extractPlayByPlayData, resolveSheetDataBatter } from '../Utils/DataProcess'

const LeaderboardBatter = ({data, loading}) => {

  return (
    <>
      <div className="wrapper">
        <div className="wrap setin">
          <div className="person_score">
            <div className="title_frame">
              <div className="breadcrumbs2">打者排行 / 測試會排行榜打者</div>
              <div className="title">測試會排行榜打者</div>
            </div>
          </div>
        </div>
      </div>
      <div className="wrapper bg_gray">
        {
          loading? 
          <div className="table_loading">Loading...</div>:
          <LeaderBoardTableFrame type='batter' 
            data={{...resolveSheetDataBatter(data[0].data, data[1].data, data[5].data), tradstat: extractPlayByPlayData(data[0].data, data[1].data).bStat}} 
          />}
      </div>
    </>
  )
}

export default LeaderboardBatter